import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AppWrapper from '../../../components/AppWrapper';
import PageAction from '../../../components/PageAction';
import PageTitle from '../../../components/PageTitle';
import TableBasic from '../../../components/Tablebasic';
import { useHospital } from '../../../hooks';
import { breachcrumbPath } from '../../../utils/breadcrumbConst';

const Hospital = () => {
  const location: any = useLocation();
  const {
    nameSingle,
    name,
    baseUrl,
    hospitals,
    selectHospitals,
    getHospitals,
    handleCheck,
    selectedValue,
    setSelectedValue,
    handleMenuAction,
  } = useHospital();

  const [toastMessage, setToastMessage] = useState<IToastMessage>();

  useEffect(() => {
    getHospitals();
  }, []);

  useEffect(() => {
    if (location.state?.toastMessage) {
      setToastMessage(location.state.toastMessage);
    }
  }, [location]);

  return (
    <AppWrapper
      toastMessage={toastMessage}
      breadcrumbs={[breachcrumbPath.core, breachcrumbPath.hospitals]}
    >
      <PageTitle
        title={`Select ${nameSingle} to change`}
        linkUrl={`/${baseUrl}/add`}
        buttonText={`add ${nameSingle}`}
        useIcon
        showButton
      />
      <PageAction
        name={nameSingle}
        count={hospitals.length}
        selectedCount={selectHospitals.length}
        selectedValue={selectedValue}
        onChange={setSelectedValue}
        handleClick={handleMenuAction}
      />
      <TableBasic
        data={hospitals || []}
        selectedList={selectHospitals}
        handleCheck={handleCheck}
        footerText={`${hospitals.length} ${name}`}
        basicUrl={`/${baseUrl}`}
      />
    </AppWrapper>
  );
};

export default Hospital;
